module.exports = __webpack_public_path__ + "static/media/gunkan_unagi_spicy.94f33920.jpeg";